module.exports = __webpack_public_path__ + "static/media/image (17).1a0aff99.jpg";